import React from "react";
import PropTypes from "prop-types";
import Form from "../../common/Form";
import Toelating from "../shared/Toelating";
import { ToelatingTypes } from "../../../constants/DomainConstants";
import { orderByPropertyName } from "../../../util/orderBy";
import { COLOR_BLACK } from "../../../constants/ComponentConstants";

const ToelatingenForm = (props) => {
    const {
        models,
        onChange,
        onSave,
        getError,
        disabled,
        color,
        onUploadFiles,
        onDeleteFile,
        fileComponents,
        downloadFileUrl,
        bewijsstukkenFileTypes,
        validationMessageType,
        hasFinalStatus,
        doorANBGebiedGereden,
        tochtMoetToelatingKrijgenVanAWV
    } = props;

    const mapChange = (modelId) => {
        return function (event) { onChange(event, modelId); };
    };

    const mapGetError = (modelId) => {
        return function (propertyName) { return getError(propertyName, modelId); };
    };

    function getTooltipText(type) {
        let text = "";

        switch (type) {
            case ToelatingTypes.ANDERE:
                text = "Hierin kunnen alle goedkeuringen en toelatingen opgeladen worden van openbare instanties en privé-eigenaren zoals de Vlaamse waterweg nv, de Vlaamse milieumaatschappij, het ministerie van defensie, de provincie, natuurpunt, ...";
                break;
        }

        return text;
    }

    const getToelatingComponentsForType = (type) => {
        const filteredToelatingen = orderByPropertyName(models.filter(m => m.type === type), "gemeenteNaam");

        const componentsForType = !models || filteredToelatingen.filter(m => m.type === type).map(model =>
                <Toelating
                    key={model.id}
                    model={model}
                    onChange={mapChange(model.id)}
                    getError={mapGetError(model.id)}
                    disabled={disabled || model.disabled || model.type === ToelatingTypes.GEMEENTE || (hasFinalStatus && type !== ToelatingTypes.ANDERE)}
                    onDropFiles={onUploadFiles}
                    onDeleteFile={onDeleteFile}
                    fileComponents={fileComponents}
                    downloadFileUrl={downloadFileUrl}
                    color={color}
                    bewijsstukkenFileTypes={bewijsstukkenFileTypes}
                    validationMessageType={validationMessageType}
                    isRequired={type === ToelatingTypes.ANDERE}
                />
        );
        return (type === ToelatingTypes.ANB && doorANBGebiedGereden === true) || (type === ToelatingTypes.AWV && tochtMoetToelatingKrijgenVanAWV === true) || (type !== ToelatingTypes.ANB && type !== ToelatingTypes.AWV) ?
            componentsForType
            : null;
    };

    const toelatingComponents = (models) =>{
        if(!models || !models.length) return null;

        const toelatingComponents = [getToelatingComponentsForType(ToelatingTypes.AWV), getToelatingComponentsForType(ToelatingTypes.ANB), getToelatingComponentsForType(ToelatingTypes.GEMEENTE)];

        return toelatingComponents;
    };

    return (
        <div>
            {toelatingComponents(models)}
            <Form name="Goedkeuringen"
                title={"Andere goedkeuringen"}
                isNotRequired
                leftButtonLabel={"Bewaar"}
                onLeftButtonClick={onSave}
                leftButtonDisabled={disabled}
                color={color}
                tooltip={getTooltipText(ToelatingTypes.ANDERE)}
                tooltipIconColor = {COLOR_BLACK}
                tooltipColor = {COLOR_BLACK}
                tooltipWindowWidth={30}>
                {(!models || !models.length) ?
                    null :
                    [getToelatingComponentsForType(ToelatingTypes.ANDERE)]
                }

            </Form>
        </div>);
};

ToelatingenForm.propTypes = {
    models: PropTypes.array,
    onChange: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
    getError: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
    readonly: PropTypes.bool,
    color: PropTypes.string,
    onUploadFiles: PropTypes.func.isRequired,
    onDeleteFile: PropTypes.func.isRequired,
    fileComponents: PropTypes.object.isRequired,
    downloadFileUrl: PropTypes.string.isRequired,
    bewijsstukkenFileTypes: PropTypes.object.isRequired,
    validationMessageType: PropTypes.string,
    hasFinalStatus: PropTypes.bool,
    doorANBGebiedGereden: PropTypes.bool,
    tochtMoetToelatingKrijgenVanAWV: PropTypes.bool
};

export default ToelatingenForm;